<template>
  <div class="section-container">
    <div class="main-container">
      <div class="type-wrap">
        <router-link to="/" class="home-page">首页></router-link>
        <span class="type-name">伟嘉视角</span>
      </div>
      <div class="page__title">
        <h2 class="large__title">伟嘉视角</h2>
        <h4 class="small__title square">COMPANY PERSPECTIVE</h4>
      </div>
      <div class="container clearfix">
        <Menubar
          :menu-list="articleTypeArr"
          @sub-menu-click="subMenuClick"/>
        <!-- <div class="menu" ref="side">
          <div class="menu-item" v-for="(item, index) in articleTypeArr" :key="item.id">
            <a class="icon iconfont" href="javascript:;" @click="menuClick(item.sub[0], index, $event)" :class="[item.cls, {'active': select === index}]">{{item.name}}</a>
            <div class="sub-menu" v-show="select === index">
              <div class="sub-menu-item" v-for="sub in item.sub" :key="sub.id">
                <a class="sub-menu-item-a" href="javascript:void(0);" @click="subMenuClick(sub, $event)">{{sub.name}}</a>
              </div>
            </div>
          </div>
        </div> -->
        <div class="content">
          <ArticleList
            v-show="articleList.length > 0"
            :articleList="articleList"
            :article-time="'addDate'"
            :show-copy-right='false'
            @item-click="articleClick" />
          <Loading
            v-show="articleList.length === 0"
            :height="100"
            :is-no-more="articleListNoMore"/>
        </div>
      </div>
      <div class="pagebox">
        <Pagination
          :count="count"
          :current-page="currentPage"
          :page-size="pageSize"
          @on-page-click="onPageClick"/>
      </div>
    </div>
    <div class="page-caption">
      <div class="point"></div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import ArticleList from '@/components/consultant/article-list'
  import Pagination from '@/components/combo/pagination'
  import Menubar from '@/components/combo/menubar'
  import Loading from '@/components/combo/loading'

  export default {
    components: {
      ArticleList,
      Pagination,
      Menubar,
      Loading
    },
    data () {
      return {
        articleTypeArr: [],
        typeId: null,
        articleList: [],
        pageSize: 16,
        count: 0,
        currentPage: 1,
        articleListNoMore: false
      }
    },
    created () {
      this._fetchArticleType()
    },
    methods: {
      _fetchArticleType () {
        let vm = this
        this.$http({
          url: '/getWJViewArticleType.jhtml',
          data: {},
          done (articleTypeArr) {
            articleTypeArr = articleTypeArr.map((item) => {
              if (item.name === '热点分析') {
                item.cls = 'analysis'
              } else if (item.name === '服务案例') {
                item.cls = 'case'
              } else if (item.name === '政策解读') {
                item.cls = 'policy'
              } else {
                item.cls = 'folder'
              }
              return item
            })
            vm.articleTypeArr = articleTypeArr
            vm.typeId = vm.articleTypeArr[0] ? vm.articleTypeArr[0].sub[0].id : ''
            vm.fetchArticlesByType()
          }
        })
      },
      fetchArticlesByType () {
        this.articleList = []
        let vm = this
        this.articleListNoMore = false
        this.$http({
          url: '/getWJViewArticles.jhtml',
          data: {
            typeId: vm.typeId || '',
            isPage: 'y',
            pageSize: vm.pageSize,
            pageNumber: vm.currentPage || 1
          },
          done (articleList, page) {
            setTimeout(() => {
              vm.articleList = [].concat(articleList)
              vm.page = page || {}
              vm.count = page.count
              if (vm.articleList.length === 0) {
                vm.articleListNoMore = true
              }
            }, 200)
          }
        })
      },
      subMenuClick (sub, index) {
        this.typeId = sub.id
        this.currentPage = 1
        this.fetchArticlesByType()
      },
      onPageClick (currentPage) {
        this.currentPage = currentPage
        this.fetchArticlesByType()
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      },
      articleClick (item) {
        window.open(`/about/perspective/${item.id}`)
        // this.$router.push(`/about/perspective/${item.id}`)
      }
    }
  }
</script>

<style type="text/css" lang="stylus" scoped>
  .main-container
    padding-top 46px
    .small__title
      padding-left 216px
  .container
    margin-top 46px
    .content
      float right
      padding-left 20px
      width 952px
      margin 0
  .pagebox
    padding 90px 0 80px

  .type-wrap
    position absolute
    top 24px
    font-size 12px
    span
      color #333
    .type-name
      font-family MicrosoftYaHei
      color #2b9efc
    .home-page
      text-decoration none
      color #333
</style>



// WEBPACK FOOTER //
// perspective.vue?55077ee4